
import { Route, RouteObject } from 'react-router-dom';
import { uxHistoryRoutes } from './history';
import { uxMessagingRoutes } from './messaging';
import { uxListsRoutes } from './lists';


import { workflowsSetupRoutes } from "./work-flow/routes";
import { templatesSetupRoutes } from "./templates/routes";
import { dashboardSetupRoutes } from "./dashboard";

export interface uxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxRoute[];
}


export const uxRoutes: uxRoute[] = [
  ...uxHistoryRoutes,
  ...uxMessagingRoutes,
  ...uxListsRoutes,
  ...dashboardSetupRoutes,
  ...workflowsSetupRoutes,
  ...templatesSetupRoutes,
]

